var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"left-box"},[_c('breadcrumb',{staticClass:"breadcrumb-container",attrs:{"id":"breadcrumb-container"}})],1),_c('div',{staticClass:"right-box"},[_c('UserPopover')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }